export default "__VITE_PUBLIC_ASSET__aed3e90b__"